<template>
    <div class="p-2 my-4 custom-residence-box" style='border:1px solid #009994 ; border-radius: 5px;'>
        <div class="form-group">
            <label>{{ tra.accommodation_description }}</label>
            <input 
                :value="customResidence.description"
                @input="updateDescription"
                type="text" 
                class="form-control"
                :placeholder="tra.accommodation_description"
            >
        </div>
        
        <div class="form-group">
            <label>{{ tra.price_per_week }}</label>
            <input 
                :value="customResidence.price"
                @input="updatePrice"
                type="number" 
                class="form-control"
            >
        </div>

        <button 
            @click="$emit('choose-custom-residence')" 
            type="button"
            class="btn rounded-10 bg-main-color mb-3 text-white"
        >
            {{ tra.add }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'CustomResidenceForm',
    props: {
        customResidence: Object,
        tra: Object,
    },
    emits: ['update-custom-residence', 'choose-custom-residence'],
    methods: {
        updateDescription(event) {
            this.$emit('update-custom-residence', {
                ...this.customResidence,
                description: event.target.value
            });
        },
        updatePrice(event) {
            this.$emit('update-custom-residence', {
                ...this.customResidence,
                price: event.target.value
            });
        }
    }
};
</script>